/**
 * Module NEUTRE « logo-grid » — KEEP IN SYNC avec
 * inventozen-frontpublic/src/cms-puck/logo-grid.ts
 */
import {
  clampColumnCount,
  MAX_CONTENT_COLUMNS,
} from "@/lib/cms-puck/blocks/column-count";
import { normalizeAttachmentIds } from "@/lib/cms-puck/blocks/gallery";

export type LogoGridColumns = number;
export type LogoGridSize = "sm" | "md" | "lg";

/** @deprecated Préférer `contentColumnsGridAttrs`. */
export const LOGO_GRID_CLASS: Record<2 | 3 | 4, string> = {
  2: "grid-cols-2 sm:grid-cols-2",
  3: "grid-cols-2 sm:grid-cols-3",
  4: "grid-cols-2 sm:grid-cols-4",
};

export const LOGO_SIZE_CLASS: Record<LogoGridSize, string> = {
  sm: "h-8 max-h-8",
  md: "h-12 max-h-12",
  lg: "h-16 max-h-16",
};

export function normalizeLogoGridColumns(value: unknown): number {
  return clampColumnCount(value, {
    min: 1,
    max: MAX_CONTENT_COLUMNS,
    fallback: 4,
  });
}

export function normalizeLogoGridSize(value: unknown): LogoGridSize {
  const v = String(value ?? "");
  if (v === "sm" || v === "md" || v === "lg") return v;
  return "md";
}

export { normalizeAttachmentIds };
